import { useMemo } from 'react';

import { useSDK } from '../app';

export const useShouldDisplayOperatorInfo = (options: string[]): boolean => {
	const { welcomeDataStore } = useSDK();

	return useMemo(
		() =>
			!!welcomeDataStore.data?.showcase.showOperatorInfoOption &&
			options.includes(welcomeDataStore.data.showcase.showOperatorInfoOption),
		[options, welcomeDataStore.data?.showcase.showOperatorInfoOption]
	);
};
